import { create } from "zustand";

import type { GetContainerResponseDto } from "../../generated/client/octalog-service"; // Adjust path if needed

interface StockUiState {
  // State
  selectedRecords: GetContainerResponseDto[];
  isAreaModalOpen: boolean;
  isEmptyModalOpen: boolean;

  // Actions
  setSelectedRecords: (records: GetContainerResponseDto[]) => void;
  openAreaModal: () => void;
  closeAreaModal: () => void;
  openEmptyModal: () => void;
  closeEmptyModal: () => void;

  // Derived State (Selectors)
  selectedCount: () => number;
  selectedContainerIds: () => number[];
}

export const useStockUiStore = create<StockUiState>((set, get) => ({
  // Initial State
  selectedRecords: [],
  isAreaModalOpen: false,
  isEmptyModalOpen: false,

  // Actions Implementation
  setSelectedRecords: (records) => set({ selectedRecords: records }),
  openAreaModal: () => set({ isAreaModalOpen: true }),
  closeAreaModal: () => set({ isAreaModalOpen: false }),
  openEmptyModal: () => set({ isEmptyModalOpen: true }),
  closeEmptyModal: () => set({ isEmptyModalOpen: false }),

  // Derived State Implementation
  selectedCount: () => get().selectedRecords.length,
  selectedContainerIds: () => get().selectedRecords.map((record) => record.containerId),
}));
